export default [
  {
    path: '/settings',
    name: 'settingsPage',
    component: () => import('@/views/Settings/SettingsPage.vue'),
    meta: {
      pageTitle: 'Settings',
      breadcrumb: [
        {
          text: 'Settings',
          active: true,
        },
      ],
    },
  },
]
